"use client"

import React from 'react'
import SignupForm1 from './sign-up-form-1'
import { useSignupFormStepsContext } from '../../../context/signup-form-steps-context'
import SignUpFormNavigator from './sign-up-form-navigator'

interface SignupFormProps {
    selectedRole?: 'volunteer' | 'homeowner' | null
    showRoleButtons?: boolean
    onRoleSelected?: (role: 'volunteer' | 'homeowner') => void
}

function SignupForm({ selectedRole, showRoleButtons, onRoleSelected }: SignupFormProps = {}) {
    const { registrationOtpSent } = useSignupFormStepsContext()
    return (
        <div className='flex flex-col gap-1.5'>
            {/* Hide form fields during OTP step - show only focused OTP entry */}
            {!registrationOtpSent && <SignupForm1 selectedRole={selectedRole} />}
            <SignUpFormNavigator
                selectedRole={selectedRole}
                showRoleButtons={showRoleButtons}
                onRoleSelected={onRoleSelected}
            />
        </div>
    )
}

export default SignupForm